// ============= Component =============

import { LoadingSpinner } from '@tw/tw-component-library';
import {
  SessionTemplateButton,
  SessionTemplateModalActions,
  SessionTemplateModalCard,
  SessionTemplateModalOverlay,
  SessionTemplateModalText,
  SessionTemplateModalTitle,
} from './Landingpage.styles';

export interface LandingPageSessionTemplateModalProps {
  isApplying: boolean;
  onAskSessionTemplate: () => void;
  onWorkspaceSessionTemplate: () => void;
}

export const LandingPageSessionTemplateModal: React.FC<
  LandingPageSessionTemplateModalProps
> = ({ isApplying, onAskSessionTemplate, onWorkspaceSessionTemplate }) => (
  <SessionTemplateModalOverlay role="dialog" aria-modal="true">
    <SessionTemplateModalCard>
      <SessionTemplateModalTitle>
        Choose your default session template
      </SessionTemplateModalTitle>
      <SessionTemplateModalText>
        Pick how LitiumTW should start for you. This preference is saved and
        only asked once.
      </SessionTemplateModalText>
      <SessionTemplateModalActions>
        <SessionTemplateButton
          type="button"
          $variant="primary"
          disabled={isApplying}
          onClick={onAskSessionTemplate}
        >
          {isApplying ? (
            <>
              <LoadingSpinner size="small" />
              Opening Ask Session...
            </>
          ) : (
            'Ask Session Template'
          )}
        </SessionTemplateButton>
        <SessionTemplateButton
          type="button"
          $variant="secondary"
          disabled={isApplying}
          onClick={onWorkspaceSessionTemplate}
        >
          Workspace Session Template
        </SessionTemplateButton>
      </SessionTemplateModalActions>
    </SessionTemplateModalCard>
  </SessionTemplateModalOverlay>
);
